import React from "react";
import { Collapse, Space, Form } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import ChildrenAnimationWrapper from "../../animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../../animations/AnimationChildWrapper";
import CheckBoxItem from "../../forms/CheckBoxItem";
import { useIntl } from "react-intl";
const { Panel } = Collapse;

const checklistItems = [
  "conversation",
  "medical_documents",
  "claim_filed",
  "inspection",
  "results",
];

const Checklist = ({ record }) => {
  const intl = useIntl();
  const [form] = Form.useForm();

  const onSubmit = (values) => {};

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onValuesChange = (values, all) => {};

  return (
    <div className="component">
      <Space direction="vertical" size="small" style={{ width: "100%" }}>
        <Collapse
          bordered={false}
          defaultActiveKey={["1"]}
          expandIcon={({ isActive }) => (
            <CaretRightOutlined rotate={isActive ? 90 : 0} />
          )}
          className="custom-collapse-section no-space"
          style={{ padding: 0, margin: 0 }}
        >
          <Panel
            header={intl.formatMessage({
              id: "app.opportunities.claim_process",
            })}
            key={"1"}
          >
            <Form
              onFinish={onSubmit}
              onFinishFailed={onFinishFailed}
              form={form}
              onValuesChange={onValuesChange}
            >
              <ChildrenAnimationWrapper>
                {checklistItems.map((item, index) => (
                  <AnimationChildWrapper key={index} itemKey={index + 1}>
                    <CheckBoxItem
                      name={item}
                      category="opportunity"
                      style={{ margin: 0 }}
                      disabled={true}
                    />
                  </AnimationChildWrapper>
                ))}
              </ChildrenAnimationWrapper>
            </Form>
          </Panel>
        </Collapse>
      </Space>
    </div>
  );
};

export default Checklist;
